"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LlmAnswer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ModalContext_1 = require("../context/ModalContext");
require("../styles.scss");
const textUtil_1 = require("../common/textUtil");
const LlmAnswer = () => {
    var _a, _b;
    const context = (0, react_1.useContext)(ModalContext_1.ModalContext);
    const scrollRef = (0, react_1.useRef)(null);
    const currentResponseAnswer = (_b = (_a = (0, textUtil_1.getCurrentResponse)(context.responses, context.showResponseIndex)) === null || _a === void 0 ? void 0 : _a.answer) !== null && _b !== void 0 ? _b : '';
    (0, react_1.useEffect)(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [currentResponseAnswer]);
    const actionUndo = () => {
        context.updateState({
            showResponseIndex: Math.max(context.showResponseIndex - 1, 0),
        });
    };
    const actionRedo = () => {
        context.updateState({
            showResponseIndex: Math.min(context.showResponseIndex + 1, context.responses.length - 1),
        });
    };
    const renderButtons = () => {
        if (context.responses.length > 1) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "pager", children: (0, jsx_runtime_1.jsxs)("ul", { className: "pagination m-t-0 m-b-0", children: [(0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", { onClick: actionUndo, children: "\u00AB" }) }), (0, jsx_runtime_1.jsx)("li", { className: "unactive", children: (0, jsx_runtime_1.jsxs)("a", { children: [context.showResponseIndex + 1, " / ", context.responses.length] }) }), (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", { onClick: actionRedo, children: "\u00BB" }) })] }) }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "wpj-form-group", children: [(0, jsx_runtime_1.jsx)("label", { children: "Odpov\u011B\u010F" }), (0, jsx_runtime_1.jsx)("div", { className: 'form-control scrollable-div', ref: scrollRef, dangerouslySetInnerHTML: {
                            __html: currentResponseAnswer,
                        } })] }), renderButtons()] }));
};
exports.LlmAnswer = LlmAnswer;
